export const uk = {
    'button-cancel': 'Отмена',
    'button-submit': 'Применить'
};
